export default __webpack_public_path__ + "static/media/Manufacturer.256.61dfcb64.png";